import React from "react";
import {
  ActivityIndicator,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

type RecordingRecoveryPanelProps = {
  pendingCount: number;
  isRecovering: boolean;
  onRetry: () => void;
};

const RecordingRecoveryPanel: React.FC<RecordingRecoveryPanelProps> = ({
  pendingCount,
  isRecovering,
  onRetry,
}) => {
  if (pendingCount <= 0 && !isRecovering) {
    return null;
  }

  return (
    <View style={styles.container}>
      <Text style={styles.text}>
        {isRecovering
          ? "Recovering uploads..."
          : `${pendingCount} recording${pendingCount === 1 ? "" : "s"} waiting to finish upload`}
      </Text>
      <TouchableOpacity
        accessibilityRole="button"
        accessibilityLabel="Retry uploads"
        disabled={isRecovering}
        onPress={onRetry}
        style={[styles.button, isRecovering && styles.buttonDisabled]}
      >
        {isRecovering ? (
          <ActivityIndicator size="small" color="#FFFFFF" />
        ) : (
          <Text style={styles.buttonText}>Retry Upload</Text>
        )}
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
    padding: 12,
    borderRadius: 8,
    backgroundColor: "#FFF8E1",
    borderWidth: 1,
    borderColor: "#FFE082",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
  },
  text: {
    flex: 1,
    color: "#5D4037",
    fontSize: 12,
    fontWeight: "500",
  },
  button: {
    minHeight: 44,
    justifyContent: "center",
    backgroundColor: "#0085FF",
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  buttonDisabled: {
    opacity: 0.7,
  },
  buttonText: {
    color: "#FFFFFF",
    fontWeight: "700",
    fontSize: 12,
  },
});

export default RecordingRecoveryPanel;
